export enum ProductType {
  PasswordManager = 0,
  SecretsManager = 1,
}
